(() => {
  if (window.VeloireHomeFeature) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);

  const setup = (feature) => {
    if (feature.dataset.veloireHomeReady === 'true') return;
    feature.dataset.veloireHomeReady = 'true';

    const video = feature.querySelector('[data-veloire-home-video]');
    const toggle = feature.querySelector('[data-veloire-home-video-toggle]');
    if (!video || !toggle) return;
    toggle.hidden = false;

    const update = () => {
      const playing = !video.paused && !video.ended;
      feature.classList.toggle('is-playing', playing);
      toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
      toggle.setAttribute('aria-label', playing ? 'Pause Veloire film' : 'Play Veloire film');
    };

    const play = () => video.play().catch(() => undefined);
    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (video.paused) play(); else video.pause();
    });

    video.addEventListener('playing', update);
    video.addEventListener('pause', update);
    video.addEventListener('ended', update);

    if (!reducedMotion.matches && !saveData) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          play();
          observer.disconnect();
        }, { rootMargin: '200px 0px' });
        observer.observe(feature);
      } else {
        play();
      }
    }

    update();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-veloire-home-feature]').forEach(setup);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.VeloireHomeFeature = { init };
})();
